import { render } from "./collage-block.vue?vue&type=template&id=bdc6788e"
import script from "./collage-block.vue?vue&type=script&lang=js"
export * from "./collage-block.vue?vue&type=script&lang=js"

import "./collage-block.vue?vue&type=style&index=0&id=bdc6788e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__